<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="24"
    width="24"
    viewBox="0 0 27.73 27.73"
    style="enable-background:new 0 0 27.73 27.73;"
    xml:space="preserve"
  >
    <path
      id="Path_1360"
      d="M4.84,15.82h3.04v6.93H4.84V15.82z M14.6,15.13h3.03v7.62H14.6L14.6,15.13z M9.71,11h3.06v11.75H9.71V11z M19.47,7.78h3.05v14.97h-3.06L19.47,7.78z M3.24,24.2h20.84V3.91H3.24V24.2z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ReportsIcon',
};
</script>
